import _ from 'lodash';
import { getAccessToken } from './helpers';
const jwtDecode = require('jwt-decode');
const qs = require('qs');

const BASE_PATH = process.env.PUBLIC_URL + '/mock-api/';
const MAPPING_FILE = 'url-mapping.txt';

const parseUrl = (pattern: string) => {
	const queryParameterDelimiterPos = pattern.indexOf('?');
	let endpoint;
	let queryParameters: any = {};
	if (queryParameterDelimiterPos !== -1) {
		endpoint = pattern.substring(0, queryParameterDelimiterPos);
		queryParameters = qs.parse(pattern.substring(queryParameterDelimiterPos + 1));
	} else {
		endpoint = pattern;
	}
	return {
		endpoint,
		queryParameters
	}
}

class MappingDefinition {
	urlPattern: string;
	fileNamePattern: string;

	constructor(urlPattern: string, fileNamePattern: string) {
		this.urlPattern = urlPattern;
		this.fileNamePattern = fileNamePattern;
	}

	createUrlFilter() {
		const { endpoint, queryParameters } = parseUrl(this.urlPattern);
		const expectedEndpointRegex = new RegExp('^' + endpoint.replace(/:id/g, '[^/]+') + '$');
		return (actualEndpoint: string, actualQueryParameters: any) => {
			if (expectedEndpointRegex.test(actualEndpoint)) {
				return _.every(Object.keys(queryParameters), (param => (queryParameters[param] === actualQueryParameters[param])));
			} else {
				return false;
			}
		};
	}

	getFileName(username: string|undefined) {
		if (username !== undefined) {
			return this.fileNamePattern.replace(':username', username);
		} else {
			return this.fileNamePattern;
		}
	}
}

export class MockApi {

	static LOGIN_ENDPOINT = '/login';

	mappingDefinitionsPromise: Promise<MappingDefinition[]>;

	constructor() {
		this.mappingDefinitionsPromise = MockApi.fetchMappingData()
			.then(mappingData => MockApi.parseMappingDefinitions(mappingData));
	}

	static fetchMappingData() {
		return fetch(BASE_PATH + MAPPING_FILE).then(response => response.text())
	}

	static parseMappingDefinitions(mappingData: string) {
		const results: MappingDefinition[] = [];
		const lines = mappingData.split('\n');
		for (let i = 0; i < lines.length; i += 1) {
			const definition = lines[i].trim();
			if (definition.length > 0) {
				const parts = definition.split(/[ \t]+/);
				if (parts.length !== 2) {
					throw new Error('Invalid mapping at line ' + (i + 1));
				} else {
					const urlPattern = parts[0];
					let fileNamePattern = parts[1];
					results.push(new MappingDefinition(urlPattern, fileNamePattern));
				}
			}
		}
		return results;
	}

	static getUsername(endpoint: string, postData: any, accessToken: string|null) {
		if (endpoint === MockApi.LOGIN_ENDPOINT) {
			return postData.username;
		} else {
			if (accessToken !== null) {
				return jwtDecode(accessToken).sub;
			} else {
				return undefined;
			}
		}
	}

	getFileName(endpoint: string, postData: any, queryParameters: any) {
		return this.mappingDefinitionsPromise.then(definitions => {
			const definition = definitions.find(definition => {
				const filter = definition.createUrlFilter();
				return filter(endpoint, queryParameters);
			});
			if (definition !== undefined) {
				const username = MockApi.getUsername(endpoint, postData, getAccessToken());
				return definition.getFileName(username);
			} else {
				throw new Error('No definition for ' + endpoint);
			}
		});
	}

	getUrl(endpointAndQueryParameters: string, postData: any) {
		const { endpoint, queryParameters } = parseUrl(endpointAndQueryParameters);
		return this.getFileName(endpoint, postData, queryParameters)
			.then(fileName => BASE_PATH + fileName)
	}
};